import { Grid } from '@sbercloud/uikit-product-site-grid';
import { SectionBasic } from '@sbercloud/uikit-product-site-section';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { Case } from 'src/types/backendContent';

import { CasesItem } from './CasesItem';

type CasesCardsProps = {
  countOfCases: number;
  setCountOfCases: React.Dispatch<React.SetStateAction<number>>;
  casesByCategory: Case[];
  buttonMoreTitle: string;
  className?: string;
  pagePath: 'cases' | 'partners';
};

export function CasesCards({
  countOfCases,
  setCountOfCases,
  casesByCategory,
  buttonMoreTitle,
  className = '',
  pagePath,
}: CasesCardsProps) {
  const casesItemsGroup = casesByCategory.slice(0, countOfCases);
  const layoutType = useLayoutType();

  const { clickAnalytics } = useAnalytics();

  return (
    <SectionBasic
      layoutType={layoutType}
      className={className}
      moreButton={
        countOfCases < casesByCategory.length
          ? {
              label: buttonMoreTitle,
              onClick: () => {
                setCountOfCases(countOfCases + 6);
                clickAnalytics({
                  action: 'click',
                  clickZone: 'body',
                  clickElement: 'button',
                  clickContent: buttonMoreTitle,
                  uniqueId: `cases-show-more-button-${buttonMoreTitle}`,
                  transitionType: 'inside-link',
                  clickZoneCategory: 'site-body',
                });
              },
            }
          : undefined
      }
    >
      <Grid
        columnsConfig={{
          desktop: { amount: 2, minWidth: 300 },
          tablet: { amount: 1, minWidth: 220 },
          mobile: { amount: 1, minWidth: 180 },
        }}
        layoutType={layoutType}
      >
        {casesItemsGroup?.map((card) => {
          const { categories, slug, title, image, id, ...rest } = card;

          return (
            <CasesItem
              key={id}
              link={slug}
              pagePath={pagePath}
              categories={categories}
              image={image}
              title={title}
              rest={rest}
            />
          );
        })}
      </Grid>
    </SectionBasic>
  );
}
